import { ProfileInfoCopyButton } from "@components/common/profile-info-copy-button";
import { DeleteMember } from "@components/delete-member/delete-member";
import { Impersonation } from "@components/impersonation/impersonation";
import { BaseMemberProps } from "@custom-types/base-types";
import { ChangeMemberAuthentication } from "@components/change-member-authentication";
import { ResetMemberPassword } from "@components/reset-member-password";
import { EditMember } from "@components/edit-member";
import { LegacyAdminPanelLink } from "@components/links/legacy-admin-panel-link";
import { RevokeMemberSessions } from "@components/revoke-member-sessions";

/** List of actions performed on a member in member information tab */
export function MemberInfoActions({
  member,
}: BaseMemberProps): React.JSX.Element {
  return (
    <>
      <LegacyAdminPanelLink subjectType="USER" id={member.identity} />
      <ProfileInfoCopyButton subjectType="USER" entity={member} />
      <EditMember member={member} />
      <Impersonation type="user" subjectId={member.identity} />
      <ResetMemberPassword
        memberId={member.identity}
        providerId={member.providerId}
      />
      <ChangeMemberAuthentication member={member} />
      <RevokeMemberSessions memberId={member.identity} />
      <DeleteMember member={member} />
    </>
  );
}
